export default __webpack_public_path__ + "static/media/up_to_us_logo_black.52121a7d.svg";